module.exports = {
      id: "story-play-usage",
      viewBox: "0 0 35 35",
      url: __webpack_public_path__ + "svg-sprite-9bf32fda02e4f885c0073d291388af8d.svg#story-play",
      toString: function () {
        return this.url;
      }
    }